/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnsupportedBrowserRouteImport } from './routes/unsupported-browser'
import { Route as IndexRouteImport } from './routes/index'

const UnsupportedBrowserRoute = UnsupportedBrowserRouteImport.update({
  id: '/unsupported-browser',
  path: '/unsupported-browser',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/unsupported-browser': typeof UnsupportedBrowserRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/unsupported-browser': typeof UnsupportedBrowserRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/unsupported-browser': typeof UnsupportedBrowserRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/unsupported-browser'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/unsupported-browser'
  id: '__root__' | '/' | '/unsupported-browser'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  UnsupportedBrowserRoute: typeof UnsupportedBrowserRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/unsupported-browser': {
      id: '/unsupported-browser'
      path: '/unsupported-browser'
      fullPath: '/unsupported-browser'
      preLoaderRoute: typeof UnsupportedBrowserRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  UnsupportedBrowserRoute: UnsupportedBrowserRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
